<template>
  <div>
    <!-- modal -->
    <b-modal
      id="lawMatterSubjectFormModal"
      centered
      size="lg"
      no-close-on-backdrop
      ref="lawMatterSubjectFormModal"
      :title="$t('lawMatterSubject.info')"
      :cancel-title="$t('others.cancel_title')"
      :ok-title="$t('others.ok_title')"
      cancel-variant="outline-secondary"
      @ok.prevent="addOrUpdate"
      @close="clear()"
      @cancel ="clear()"
    >
      <validation-observer ref="simpleRules">
        <b-form>
          <label for="law-matter-sub-subject-name-input">{{
            $t("lawMatterSubject.type")
          }}</label>
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              :name="$t('lawMatterSubject.type')"
              rules="required"
            >
              <b-form-input
                id="law-matter-sub-subject-name-input"
                v-model="name"
                size="sm"
                maxlength="50"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-form>
      </validation-observer>
      <b-card :hidden="hideSubSubjects">
        <b-form>
          <b-row>
            <b-col class="mt-2">
              <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                <b-tab
                  :title="$t('Law Matter Sub Subject')"
                  active
                  style="width: 100%"
                >
                  <b-card-text>
                    <law-matter-sub-subject-table-form
                      ref="lawMatterSubSubjectTableForm" :subjectId="id"
                    ></law-matter-sub-subject-table-form>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-modal>
  </div>
</template>

<script>

export default {
  props: {
    getLawMatterSubjectList: {
      type: Function,
    },
  },
  data() {
    return {
      id: 0,
      name: "",
      hideSubSubjects: true,
      subSubjectList: []
    };
  },
  methods: {
    clear(){
       this.hideSubSubjects = true
    },
    async showInfo(id) {
      if(id) this.hideSubSubjects = false
      
      this.$refs["lawMatterSubjectFormModal"].show();
      this.id = id;

      const data = { id: this.id,}; 
      const controller = { name: "LawMatterSubject"};
      const payload = { data: data, controller: controller,};
       
      const response = await this.$store.dispatch("moduleAuth/getInfo",payload );
        if (response.data.resultStatus == true) {
          this.name = response.data.lawMatterSubject.name;
          this.subSubjectList = response.data.lawMatterSubSubjects
          this.$refs.lawMatterSubSubjectTableForm.lawMatterSubSubjectTableList =this.subSubjectList;
          
        } else {
          this.$bvModal.hide("lawMatterSubjectFormModal");
          this.$WarningAlert(response.data.resultMessage);
        }
    },
    async addOrUpdate() {
      
      const data = { id: this.id,name: this.name, };
      const controller = {name: "LawMatterSubject"};
      const payload = { data: data,controller: controller};
      
      const success = await this.$refs.simpleRules.validate();
      if (success) {
        const response = await this.$store.dispatch("moduleAuth/save", payload);
          if (response.data.resultStatus == true) {
            if(!this.id) this.id = response.data.id
            await this.getLawMatterSubjectList()
            this.hideSubSubjects = false;
            this.$SaveAlert()
            if(!this.id){
              await this.$refs.lawMatterSubSubjectTableForm.showLawMatterSubSubjects();
            }
            
          } else {
            this.$WarningAlert(response.data.resultMessage);
          }
      }
    },
  },
};
</script>

<style lang="scss">
[dir="ltr"] .modal-header .close {
  margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
  margin-bottom: 0.2857rem;
  font-weight: bold;
}

.modal .modal-content {
  overflow: visible;
  margin-bottom: auto;
}

[dir] .invalid-tooltip {
  padding: 0.4rem 0.775rem !important;
  margin-top: -1.5rem !important;
  background-color: #ea5455 !important;
  border-radius: 0.358rem !important;
  left: 20px !important;
}
</style>
